<template>
  <!-- Main -->
  <div id="main">
    <!-- 物流 -->
    <div id="mainLogistics">
      <div class="areaH">
        <div class="areaV">
          <div class="box" style="justify-content: flex-start;">
            <span class="title">物流設定</span>
            <a
              class="save"
              v-show="isSettingUpdated"
              @click="saveLogisticSettings"
            >
              <FontAwesomeIcon icon="save" />
            </a>
            <!-- <pre>{{ configurations }}</pre> -->
            <!-- <pre>{{ logisticVendors }}</pre> -->
            <div class="item">
              <span class="content">是否串接物流平台</span>
              <div class="tabs" style="margin-left: 10px;">
                <a
                  class="tab"
                  @click="updateSettings('logisticPlatform', 'platform');"
                  :class="{
                    active: configurations.logisticPlatform !== 'selfie'
                  }"
                >
                  <span>串接物流平台</span>
                </a>
                <a
                  class="tab"
                  @click="updateSettings('logisticPlatform', 'selfie')"
                  :class="{
                    active: (configurations.logisticPlatform === 'selfie')
                  }"
                >
                  <span>自送</span>
                </a>
              </div>
            </div>
            <!-- <div
              class="item"
              v-if="
                configurations.logisticVersion == 'v2' &&
                  configurations.logisticPlatform === 'platform'
              "
            >
              <span class="content">物流帳號 (Deprecated)</span>
              <div class="tabs" style="margin-left: 10px;">
                <a
                  class="tab"
                  @click="updateSettings('logisticWallet', 'private')"
                  :class="{
                    active: configurations.logisticWallet === 'private'
                  }"
                >
                  <span>自有物流帳號</span>
                </a>
                <a
                  class="tab"
                  @click="updateSettings('logisticWallet', 'public')"
                  :class="{
                    active: configurations.logisticWallet === 'public'
                  }"
                >
                  <span>快一點物流帳號</span>
                </a>
              </div>
            </div> -->
            <div
              class="item"
              v-if=" configurations.logisticPlatform !== 'selfie'"
            >
              <span class="content">拋單模式</span>
              <div class="tabs" style="margin-left: 10px;">
                <a
                  class="tab"
                  
                  @click="configurations.logisticPlatform !== 'selfie' ? updateSettings('logisticMode', 'auto') : '';"
                  :class="{ active: ((configurations.logisticVersion === 'v2' && configurations.logisticMode === 'auto') || configurations.logisticVersion === 'v1') }"
                >
                  <span>自動</span>
                </a>
                <a
                  class="tab"
                  :disabled="(configurations.logisticVersion === 'v1' || configurations.logisticWallet === 'public')"
                  @click="configurations.logisticPlatform !== 'selfie' ? (updateSettings('logisticMode', 'manual'), updateSettings('logisticVersion', 'v2'), updateSettings('logisticDefaultVendor', 'lala'))  : ''"
                  :class="{ active: (configurations.logisticMode === 'manual' && configurations.logisticVersion === 'v2') }"
                >
                  <span>手動</span>
                </a>
              </div>
            </div>
            <!-- 移到預設值去設定  -->
            <!-- 目前還不支援自有物流距離報價，也不支援新版物流手動設定, 只有自送可根據設定切換新舊版-->
            <div
              class="item"
            >
              <span class="content">運送時間</span>
              <div class="tabs" style="margin-left: 10px;">
                <a
                  class="tab"
                  :disabled="1"
                  @click="updateSettings('logisticVersion', 'v1'); updateSettings('logisticDefaultVendor', 'git');"
                  :class="{ active: configurations.logisticVersion === 'v1' }"
                >
                  <span>距離估算</span>
                </a>
                 <a
                  class="tab"
                  @click="updateSettings('logisticVersion', 'v2');  updateSettings('logisticDefaultVendor', 'lala');"
                  :class="{ active: configurations.logisticVersion === 'v2' }"
                >
                  <span>自訂</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="areaV">
          <div class="box">
            <div class="item">
              <span class="title">預設值</span>
              <span class="remark"> 若有自訂條件，則以自訂條件計算</span>
              <a
                class="save"
                v-show="isLogisticDefaultChanged"
                @click="saveLogisticDefault"
              >
                <FontAwesomeIcon icon="save" />
              </a>
            </div>
            <div class="item">
              <span class="content" style="min-width: 72px;"
                >路徑計算方式</span
              >
              <div class="tabs" style="width: 114px; margin-left: 10px;">
                <a 
                  class="tab"
                  :class="{ active: logisticDefaultSettings.logisticDistanceType === 'route' }"
                  @click="logisticDefaultSettings.logisticDistanceType = 'route'"
                >
                  <span>路徑</span>
                </a>
                <a class="tab"
                  :class="{ active: logisticDefaultSettings.logisticDistanceType === 'linear' }"
                  @click="logisticDefaultSettings.logisticDistanceType = 'linear'"
                >
                  <span>直線</span>
                </a>
              </div>
            </div>
            <!-- <div class="item">
              <span class="content" style="min-width: 72px;"
                >運費設定(即將開放)</span
              >
              <div class="tabs" style="width: 114px; margin-left: 10px;">
                <a class="tab">
                  <span>物流</span>
                </a>
                <a class="tab active">
                  <span>自訂</span>
                </a>
              </div>
              <div class="number" style="width: 120px; margin-left: 10px;">
                <input type="number" value="10" min="0" />
                <span class="content unit">元</span>
              </div>
            </div> -->
            <div class="item">
              <span class="content">{{configurations.logisticPlatform === 'selfie' ? '最低外送金額' : '最低免運金額'}}</span>
              <div class="number" style="width: 120px; margin-left: 10px;">
                <input
                  type="number"
                  min="0"
                  v-model="logisticDefaultSettings.deliveryAmtTh"
                />
                <span class="content unit">元</span>
              </div>
            </div>
            <div class="item">
              <span class="content">{{configurations.logisticPlatform === 'selfie' ? '最低外送數量' : '最低免運數量'}}</span>
              <div class="number" style="width: 120px; margin-left: 10px;">
                <input
                  type="number"
                  min="0"
                  v-model="logisticDefaultSettings.deliveryQtyTh"
                />
                <span class="content unit">項商品</span>
              </div>
            </div>
            <div class="item">
              <span class="content">最長外送距離</span>
              <div class="number" style="width: 120px; margin-left: 10px;">
                <input
                  type="number"
                  min="0"
                  v-model="logisticDefaultSettings.deliveryDistanceTh"
                />
                <span class="content unit">公里</span>
              </div>
            </div>
            <!-- <div class="item">
              <span class="content">額外外送時間(即將開放)</span>
              <div class="tabs" style="width: 114px; margin-left: 10px;">
                <a class="tab">
                  <span>距離</span>
                </a>
                <a class="tab active">
                  <span>自訂</span>
                </a>
              </div>
              <div class="number" style="width: 120px; margin-left: 10px;">
                <input type="number" value="5" min="0" />
                <span class="content unit">分鐘</span>
              </div>
            </div>
            <div class="item">
              <div style="display: flex; flex-direction: column;">
                <div class="item">
                  <span class="content">免運門檻金額(即將開放)</span>
                  <div class="number" style="width: 120px; margin-left: 10px;">
                    <input type="number" min="0" value="5" />
                    <span class="content unit">元</span>
                  </div>
                </div>
                <div class="item">
                  <span class="content">免運門檻數量(即將開放)</span>
                  <div class="number" style="width: 120px; margin-left: 10px;">
                    <input type="number" value="5" min="0" />
                    <span class="content unit">項商品</span>
                  </div>
                </div>
              </div>
              <label class="check" style="margin-left: 10px;">
                <input type="checkbox" name="checkbox1" />
                <span class="checkmark checkbox"></span>
                <div class="text">擇一</div>
              </label>
            </div> -->
          </div>
        </div>
      </div>
      <div class="areaH" v-if="user.type !== 'si'">
        <div
          class="areaV"
        >
          <div 
            class="box"
            :class="{ gray: configurations.logisticPlatform === 'selfie'}"
          >
            <span class="title">物流業者設定</span>
            <span class="remark">設定物流帳號即可手動拋單，自動拋單必須選擇預設業者。</span>
            <div class="item">
            <!-- todo -->
              <label
                class="check box4"
                :class="{gray: !(vendor.settings.accessKey && vendor.settings.accessKey.value) || (vendor.version !== configurations.logisticVersion)}" 
                v-for="vendor in logisticVendors"
                :key="vendor.name"
                v-show="vendor.display"
              >
                <input
                  type="radio"
                  name="logisticDefaultVendor"
                  :disabled="configurations.logisticPlatform === 'selfie'"
                  v-model="configurations.logisticDefaultVendor"
                  @click="updateLogisticVendorRelatedSetting(vendor)"
                  :value="vendor.name"
                />
                <span class="checkmark radio"></span>
                <div class="logo">
                  <img :src="vendor.img" />
                  <span>{{ vendor.title }}</span>
                </div>
                <a class="icon" @click="showLogisticVendorPopup(vendor)"
                  ><FontAwesomeIcon icon="cog"
                /></a>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="areaH" v-if="configurations.logisticVersion === 'v1' || configurations.logisticVersion === 'v2' || configurations.logisticPlatform === 'selfie'">
        <div class="areaV">
          <div class="box" style="position: relative;">
            <div class="item">
              <span class="title">自訂運送條件</span>
              <a class="add" @click="addNewRule"
                ><FontAwesomeIcon icon="plus" />
              </a>
              <a
                class="save"
                v-show="isConfigurationUpdated"
                @click="saveConfiguration"
              >
                <FontAwesomeIcon icon="save" />
              </a>
            </div>
            <!-- <a
              class="textButton"
              style="top: 10px; right: 0; position: absolute;"
              ><span>試算</span></a
            > -->
            <div class="map">
              <Polygons :id="1" :polygons="mapPolygons"> </Polygons>
            </div>
            <table>
              <tr>
                <!-- <th></th> -->
                <th><span class="content">運費</span></th>
                <th v-if="configurations.logisticVersion === 'v2'"><span class="content">運送時間</span></th>
                <th><span class="content">金額門檻</span></th>
                <th><span class="content">數量門檻</span></th>
                <th><span class="content">運送門檻</span></th>
                <th><span class="content">距離/地圖名稱</span></th>
                <th></th>
              </tr>
              <tr v-for="(rule, index) in ruleForm.ruleParams" :key="index">
                <!-- <td align="center">
                  即將開放？
                  <label class="switch" style="margin-left: 10px;">
                    <input type="checkbox" checked />
                    <span class="slider round"></span>
                  </label>
                </td> -->
                <td align="center">
                  <span class="content" v-if="rule.deliveryCharge >= 0"
                    >{{ rule.deliveryCharge }}元</span
                  >
                </td>
                <td align="center" v-if="configurations.logisticVersion === 'v2'">
                  <span class="content" v-if="rule.additionalDeliveryTime"
                    >{{ rule.additionalDeliveryTime }}分鐘</span
                  >
                </td>
                <td align="center">
                  <span class="content" v-if="rule.amountLimit"
                    >{{ rule.amountLimit }}元以上</span
                  >
                </td>
                <td align="center">
                  <span class="content" v-if="rule.qtyLimit"
                    >{{ rule.qtyLimit }}個以上</span
                  >
                </td>
                <td align="center">
                  <span class="content" v-if="rule.type === 'map'"
                    >地圖設定</span
                  >
                  <span class="content" v-else>距離設定</span>
                </td>
                <td align="center">
                  <span class="content" v-if="rule.type === 'map'">
                    {{ rule.name }}</span
                  >
                  <span class="content" v-else
                    >{{ rule.minDistanceInMeter }}-{{
                      rule.maxDistanceInMeter
                    }}公尺</span
                  >
                </td>
                <td align="center">
                  <div class="action">
                    <a @click="showDeliveryRulePopup(index)"
                      ><FontAwesomeIcon icon="pen"
                    /></a>
                    <a @click="showRemoveDialog(index)"
                      ><FontAwesomeIcon icon="trash"
                    /></a>
                    <!-- <a><FontAwesomeIcon icon="bars"/></a> -->
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- 物流 Popup -->
    <section
      id="popLogistics"
      class="popLogistics popup"
      v-if="showLogisticPopup"
      :class="{ 'display-flex': showLogisticPopup }"
    >
      <div class="popBody">
        <a class="close" @click="closeLogisticVendorPopup"
          ><FontAwesomeIcon icon="times"
        /></a>
        <section class="popHeader">
          <div class="flexH">
            <div class="img"><img :src="editableVendor.img" /></div>
            <span class="title">{{ editableVendor.title }}</span>
          </div>
        </section>
        <section class="popMain">
          <table class="content empty">
            <tr v-if="editableVendor.settings.merchantId.display">
              <td><span>Merchant ID</span></td>
              <td>
                <input
                  class="input"
                  type="text"
                  style="margin-left: 10px;"
                  v-model="editableVendor.settings.merchantId.value"
                  placeholder=""
                />
              </td>
            </tr>
            <tr v-if="editableVendor.settings.accessKey.display">
              <td><span>Access Key</span></td>
              <td>
                <input
                  class="input"
                  type="text"
                  style="margin-left: 10px;"
                  v-model="editableVendor.settings.accessKey.value"
                  placeholder=""
                />
              </td>
            </tr>
            <tr v-if="editableVendor.settings.accessToken.display">
              <td><span>Access Token</span></td>
              <td>
                <input
                  class="input"
                  type="text"
                  style="margin-left: 10px;"
                  v-model="editableVendor.settings.accessToken.value"
                  placeholder=""
                />
              </td>
            </tr>
            <tr v-if="editableVendor.settings.customQuotation.display">
              <td><span>是否自訂報價</span></td>
              <td>
                <div class="tabs" style="margin-left: 10px;">
                <a
                  class="tab"
                  @click="editableVendor.settings.customQuotation.value = 0"
                  :class="{
                    active: editableVendor.settings.customQuotation.value === 0
                  }"
                >
                  <span>不自訂報價</span>
                </a>
                <a
                  class="tab"
                  @click="editableVendor.settings.customQuotation.value = 1"
                  :class="{
                    active: editableVendor.settings.customQuotation.value === 1
                  }"
                >
                  <span>自訂報價</span>
                </a>
              </div>
              </td>
            </tr>
            <tr v-if="editableVendor.settings.defaultVendor.display">
              <td><span>預設物流</span></td>
              <td>
                <div class="dropdown full">
                  <select
                    name="type"
                    class="fM"
                    style="margin-left: 10px;"
                    v-model="editableVendor.settings.defaultVendor.value"
                  >
                    <option value="lala">Lalamove</option>
                    <option value="global">全球</option>
                    <option value="pandago">PandaGO</option>
                    <option value="uber">UberDirect</option>
                  </select>
                  <div class="arrow">
                    <FontAwesomeIcon icon="caret-down" />
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="editableVendor.settings.defaultVendor.value === 'uber'">
              <td><span>uber UUID</span></td>
              <td>
                <input
                  class="input"
                  type="text"
                  v-model="uberUUID"
                  style="margin-left: 10px;"
                  placeholder=""
                />
              </td>
            </tr>
          </table>
        </section>
        <section class="popFooter">
          <!-- <a class="button cancel white" @click="closeLogisticVendorPopup"
            ><span class="remark">取消</span></a
          > -->
          <a class="button submit"  @click="closeLogisticVendorPopup"><span class="remark">確認</span></a>
        </section>
      </div>
    </section>
    <!-- <div id="popLogistics" class="modal" v-if="false && showLogisticPopup">
      <div class="modal-content">
        <span class="close" @click="closeLogisticVendorPopup">&times;</span>
        <div class="item">
          <span class="title">{{ editableVendor.title }}</span>
        </div>
        <div id="main">
          <div class="areaH">
            <div class="areaV">
              <div
                class="item"
                v-if="editableVendor.settings.merchantId.display"
              >
                <span class="content" style="min-width: 80px;"
                  >Merchant ID</span
                >
                <input
                  class="input"
                  type="text"
                  style="margin-left: 10px;"
                  v-model="editableVendor.settings.merchantId.value"
                  placeholder=""
                />
              </div>
              <div
                class="item"
                v-if="editableVendor.settings.accessKey.display"
              >
                <span class="content" style="min-width: 80px;">Access Key</span>
                <input
                  class="input"
                  type="text"
                  style="margin-left: 10px;"
                  v-model="editableVendor.settings.accessKey.value"
                  placeholder=""
                />
              </div>
              <div
                class="item"
                v-if="editableVendor.settings.accessToken.display"
              >
                <span class="content">Access Token</span>
                <input
                  class="input"
                  type="text"
                  style="margin-left: 10px;"
                  v-model="editableVendor.settings.accessToken.value"
                  placeholder=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <a class="button cancel" @click="closeLogisticVendorPopup">取消</a>
          <a class="button submit">儲存</a>
        </div>
      </div>
    </div> -->
    <!-- 運費 Popup -->
    <section
      id="popDelivery"
      class="popDelivery popup"
      v-if="showDeliveryPopup"
      :class="{ 'display-flex': showDeliveryPopup }"
    >
      <div class="popBody">
        <a class="close" @click="closeDeliveryRulePopup"><FontAwesomeIcon icon="times"/></a>
        <section class="popHeader">
          <span class="title">新增運送條件</span>
        </section>
        <section class="popMain">
          <div class="grid delivery">
            <div class="grid5">
              <span class="title">運送設定 </span>
              <table class="content empty">
                <tr>
                  <td>
                    <span class="content"
                      ><span class="red">*</span> 運費設定</span
                    >
                  </td>
                  <td>
                    <div class="tabs">
                      <a 
                        class="tab"
                        :class="{ active: !isDeliveryRulePopupCustomSetting}"
                      >
                        <span>物流報價</span>
                      </a>
                      <a 
                        class="tab"
                        :class="{ active: isDeliveryRulePopupCustomSetting}"
                      >
                        <span>自訂</span>
                      </a>
                    </div>
                  </td>
                  <td>
                    <div class="number" v-if="isDeliveryRulePopupCustomSetting">
                      <input
                        type="number"
                        min="0"
                        v-model.number="editableRule.deliveryCharge"
                      />
                      <span class="content unit">元</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="content"
                      ><span class="red">*</span> 最低金額</span
                    >
                  </td>
                  <td>
                    <div class="number">
                      <input
                        type="number"
                        min="0"
                        v-model.number="editableRule.amountLimit"
                      />
                      <span class="content unit">元</span>
                    </div>
                  </td>
                  <!-- <td rowspan="2">
                    <label class="check">
                      <input type="checkbox" name="checkbox1" />
                      <span class="checkmark checkbox"></span>
                      <div class="text">擇一 (TBD)</div>
                    </label>
                  </td> -->
                </tr>
                <tr>
                  <td>
                    <span class="content"
                      ><span class="red">*</span> 最低數量</span
                    >
                  </td>
                  <td>
                    <div class="number">
                      <input
                        type="number"
                        min="0"
                        v-model.number="editableRule.qtyLimit"
                      />
                      <span class="content unit">項商品</span>
                    </div>
                  </td>
                </tr>
                <!-- <tr>
                  <td>
                    <span class="content"
                      ><span class="red">*</span> 外送運費 (Dep.)</span
                    >
                  </td>
                  <td>
                    <div class="number">
                      <input
                        type="text"
                        min="0"
                        v-model.number="editableRule.deliveryCharge"
                        name="外送運費"
                        v-validate="{ required: true, decimal: 2 }"
                      />
                      <span class="content unit">元</span>
                    </div>
                    <div class="is-invalid">
                      {{ errors.first("外送運費") }}
                    </div>
                  </td>
                </tr> -->
                <tr v-if="configurations.logisticVersion === 'v2'">
                  <td>
                    <span class="content"
                      ><span class="red">*</span> 外送時間</span
                    >
                  </td>
                  <td>
                    <div class="number">
                      <input
                        type="text"
                        min="0"
                        v-model.number="editableRule.additionalDeliveryTime"
                        name="外送時間"
                        v-validate="{
                          required: true,
                          integer: true,
                          min_value: 0
                        }"
                      />
                      <span class="content unit">分鐘</span>
                    </div>
                    <div class="is-invalid">
                      {{ errors.first("外送時間") }}
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <!-- 物流報價仍可補貼 -->
            <!-- <div class="grid1">
              <span class="title">補貼門檻 (即將開放)</span>
              <table class="content empty">
                <tr>
                  <td><span class="content">最低金額</span></td>
                  <td>
                    <div class="number">
                      <input type="number" value="5" min="0" />
                      <span class="content unit">元</span>
                    </div>
                  </td>
                  <td rowspan="2">
                    <label class="check">
                      <input type="checkbox" name="checkbox1" />
                      <span class="checkmark checkbox"></span>
                      <div class="text">擇一</div>
                    </label>
                  </td>
                </tr>
                <tr>
                  <td><span class="content">最低數量</span></td>
                  <td>
                    <div class="number">
                      <input type="number" value="5" min="0" />
                      <span class="content unit">項商品</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td><span class="content">外送補貼</span></td>
                  <td>
                    <div class="number">
                      <input type="number" value="5" min="0" />
                      <span class="content unit">元</span>
                    </div>
                  </td>
                </tr>
              </table>
            </div> -->
            <div class="grid6">
              <div class="flexV width height">
                <span class="title">運送距離</span>
                <table class="content empty">
                  <tr>
                    <td colspan="4">
                      <div class="tabs">
                        <a
                          class="tab"
                          @click="editableRule.type = 'distance'"
                          :class="{ active: editableRule.type === 'distance' }"
                        >
                          <span>距離設定</span>
                        </a>
                        <a
                          class="tab"
                          @click="editableRule.type = 'map'"
                          :class="{ active: editableRule.type === 'map' }"
                        >
                          <span>地圖設定</span>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="content"
                        ><span
                          class="red"
                          v-if="editableRule.type === 'distance'"
                          >*</span
                        >
                        距離</span
                      >
                    </td>
                    <td>
                      <div class="number">
                        <input
                          type="text"
                          min="0"
                          v-model.number="editableRule.minDistanceInMeter"
                          :disabled="editableRule.type === 'map'"
                          name="最近運送距離"
                          v-validate="{
                            required: editableRule.type !== 'map',
                            integer: true,
                            min_value: 0
                          }"
                        />
                        <span class="content unit">公尺</span>
                      </div>
                      <!-- <div class="is-invalid" style="margin-left: 10px;">
                        {{ errors.first("最近運送距離") }}
                      </div>
                      <div class="is-invalid">
                        {{ errors.first("最遠運送距離") }}
                      </div> -->
                    </td>
                    <td><span class="content">至</span></td>
                    <td>
                      <div class="number">
                        <input
                          type="text"
                          min="0"
                          v-model.number="editableRule.maxDistanceInMeter"
                          :disabled="editableRule.type === 'map'"
                          name="最遠運送距離"
                          v-validate="{
                            required: editableRule.type !== 'map',
                            integer: true,
                            min_value: errors.has('最近運送距離')
                              ? 0
                              : editableRule.minDistanceInMeter
                          }"
                        />
                        <span class="content unit">公尺</span>
                      </div>

                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td colspan="4" align="left">
                      <div class="is-invalid" style="margin-left: 10px;">
                        {{ errors.first("最近運送距離") }}
                      </div>
                      <div class="is-invalid" v-if="!errors.has('最近運送距離')">
                        {{ errors.first("最遠運送距離") }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="content"
                        ><span class="red" v-if="editableRule.type === 'map'"
                          >*</span
                        >
                        地圖名稱</span
                      >
                    </td>
                    <td>
                      <input
                        class="input"
                        type="text"
                        placeholder=""
                        v-model="editableRule.name"
                        :disabled="editableRule.type === 'distance'"
                        name="地圖名稱"
                        v-validate="{ required: editableRule.type === 'map' }"
                      />
                      <div class="is-invalid">
                        {{ errors.first("地圖名稱") }}
                      </div>
                    </td>
                    <td colspan="2" align="right">
                      <div>
                        <input type="file" ref="file" accept=".kml,.kmz" @change="readFile()" />
                        <div v-if="mapkml">
                          <img :src="preview" />
                        </div>
                      </div>
                      <a
                        class="textButton"
                        @click="editableRule.polygons = polygonsFromFile"
                        ><span>載入KML</span></a
                      >
                      <a
                        class="textButton"
                        @click="editableRule.polygons = []"
                        ><span>清空地圖設定</span></a
                      >
                    </td>
                  </tr>
                </table>

                <div class="map small" style="height:100px;">
                  <LogisticPolygons
                    :id="99"
                    :polygons="editableRule.polygons"
                    @updated="
                      newData => {
                        editableRule.polygons = newData;
                      }
                    "
                  >
                  </LogisticPolygons>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="popFooter">
          <a class="button cancel white" @click="closeDeliveryRulePopup"><span class="remark">取消</span></a>
          <a class="button submit" @click="updateTempRuleSettings"><span class="remark">確認</span></a>
        </section>
      </div>
    </section>
    <div id="popDelivery" class="modal" v-if="false && showDeliveryPopup">
      <div class="modal-content">
        <span class="close" @click="closeDeliveryRulePopup">&times;</span>
        <span class="title">新增運送條件</span>
        <div id="main">
          <div class="areaH">
            <div class="areaV">
              <div class="box">
                <span class="title">運送設定</span>
                <div class="item">
                  <span class="content"
                    ><span class="red">*</span> 運費設定 (即將開放)</span
                  >
                  <div class="tabs" style="width: 94px; margin-left: 10px;">
                    <a class="tab">
                      <span>物流</span>
                    </a>
                    <a class="tab active">
                      <span>自訂</span>
                    </a>
                  </div>
                  <div class="number" style="width: 90px; margin-left: 10px;">
                    <input
                      type="number"
                      min="0"
                      v-model.number="editableRule.deliveryCharge"
                    />
                    <span class="content unit">元</span>
                  </div>
                </div>
                <div class="item">
                  <div>
                    <div class="item">
                      <span class="content"> 最低金額</span>
                      <div
                        class="number"
                        style="width: 90px; margin-left: 10px;"
                      >
                        <input
                          type="number"
                          min="0"
                          v-model.number="editableRule.amountLimit"
                        />
                        <span class="content unit">元</span>
                      </div>
                    </div>
                    <div class="item">
                      <span class="content"> 最低數量</span>
                      <div
                        class="number"
                        style="width: 90px; margin-left: 10px;"
                      >
                        <input
                          type="number"
                          min="0"
                          v-model.number="editableRule.qtyLimit"
                        />
                        <span class="content unit">項商品</span>
                      </div>
                    </div>
                  </div>
                  <!-- <label class="check" style="margin-left: 10px;">
                    <input type="checkbox" name="checkbox1" :disabled="true" />
                    <span class="checkmark checkbox"></span>
                    <div class="text">擇一 （即將開放）</div>
                  </label> -->
                </div>
                <div class="item">
                  <span class="content"
                    ><span class="red">*</span> 外送運費 （Deprecated)</span
                  >
                  <!-- v-validate在input type是number時，會自動套用decimals -->
                  <div class="number" style="width: 90px; margin-left: 10px;">
                    <input
                      type="text"
                      min="0"
                      v-model.number="editableRule.deliveryCharge"
                      name="外送運費"
                      v-validate="{ required: true, decimal: 2 }"
                    />
                    <span class="content unit">元</span>
                  </div>
                  <!-- <div class="is-invalid">{{ errors.first('外送運費') }}</div> -->
                </div>
                <div class="item is-invalid">
                  {{ errors.first("外送運費") }}
                </div>
                <div class="item">
                  <span class="content"
                    ><span class="red">*</span>
                    外送時間（新版看運費設定判斷是否必填)</span
                  >
                  <div class="number" style="width: 90px; margin-left: 10px;">
                    <input
                      type="text"
                      min="0"
                      v-model.number="editableRule.additionalDeliveryTime"
                      name="外送時間"
                      v-validate="{
                        required: true,
                        integer: true,
                        min_value: 0
                      }"
                    />
                    <span class="content unit">分鐘</span>
                  </div>
                </div>
                <div class="item is-invalid">
                  {{ errors.first("外送時間") }}
                </div>
              </div>
              <div class="box">
                <span class="title">補貼門檻 (即將開放)</span>
                <div class="item">
                  <div>
                    <div class="item">
                      <span class="content">最低金額</span>
                      <div
                        class="number"
                        style="width: 90px; margin-left: 10px;"
                      >
                        <input type="number" value="5" min="0" />
                        <span class="content unit">元</span>
                      </div>
                    </div>
                    <div class="item">
                      <span class="content">最低數量</span>
                      <div
                        class="number"
                        style="width: 90px; margin-left: 10px;"
                      >
                        <input type="number" value="5" min="0" />
                        <span class="content unit">項商品</span>
                      </div>
                    </div>
                  </div>
                  <label class="check" style="margin-left: 10px;">
                    <input type="checkbox" name="checkbox1" />
                    <span class="checkmark checkbox"></span>
                    <div class="text">擇一</div>
                  </label>
                </div>
                <div class="item">
                  <span class="content">外送補貼</span>
                  <div class="number" style="width: 90px; margin-left: 10px;">
                    <input type="number" value="5" min="0" />
                    <span class="content unit">元</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="areaV">
              <div class="box">
                <span class="title">運送距離</span>
                <div class="tabs">
                  <a
                    class="tab"
                    @click="editableRule.type = 'distance'"
                    :class="{ active: editableRule.type === 'distance' }"
                  >
                    <span>距離設定</span>
                  </a>
                  <a
                    class="tab"
                    @click="editableRule.type = 'map'"
                    :class="{ active: editableRule.type === 'map' }"
                  >
                    <span>地圖設定</span>
                  </a>
                </div>
                <div class="item">
                  <span class="content" style="min-width: 56px;"
                    ><span class="red" v-if="editableRule.type === 'distance'"
                      >*</span
                    >
                    距離</span
                  >
                  <div class="number" style="width: 110px; margin-left: 10px;">
                    <input
                      type="text"
                      min="0"
                      v-model.number="editableRule.minDistanceInMeter"
                      :disabled="editableRule.type === 'map'"
                      name="最近運送距離"
                      v-validate="{
                        required: editableRule.type !== 'map',
                        integer: true,
                        min_value: 0
                      }"
                    />
                    <span class="content unit">公尺</span>
                  </div>
                  <span class="content" style="margin-left: 10px;">至</span>
                  <div class="number" style="width: 110px; margin-left: 10px;">
                    <input
                      type="text"
                      min="0"
                      v-model.number="editableRule.maxDistanceInMeter"
                      :disabled="editableRule.type === 'map'"
                      name="最遠運送距離"
                      v-validate="{
                        required: editableRule.type !== 'map',
                        integer: true,
                        min_value: errors.has('最近運送距離')
                          ? 0
                          : editableRule.minDistanceInMeter
                      }"
                    />
                    <span class="content unit">公尺</span>
                  </div>
                </div>
                <div class="item is-invalid">
                  {{ errors.first("最近運送距離") }}
                </div>
                <div class="item is-invalid">
                  {{ errors.first("最遠運送距離") }}
                </div>
                <div class="item">
                  <span class="content"
                    ><span class="red" v-if="editableRule.type === 'map'"
                      >*</span
                    >
                    地圖名稱</span
                  >
                  <input
                    class="input"
                    type="text"
                    style="margin-left: 10px;"
                    placeholder=""
                    v-model="editableRule.name"
                    :disabled="editableRule.type === 'distance'"
                    name="地圖名稱"
                    v-validate="{ required: editableRule.type === 'map' }"
                  />
                </div>
                <div class="item is-invalid">
                  {{ errors.first("地圖名稱") }}
                </div>
                <div class="map" style="height: 100%; position: relative;">
                  <div>
                    <a
                      class="textButton"
                      style="top: 10px; right: 0; position: absolute; z-index:99"
                      @click="editableRule.polygons = []"
                      ><span>清空地圖設定</span></a
                    >
                  </div>

                  <LogisticPolygons
                    :id="99"
                    :polygons="editableRule.polygons"
                    @updated="
                      newData => {
                        editableRule.polygons = newData;
                      }
                    "
                  >
                  </LogisticPolygons>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <a class="button cancel" @click="closeDeliveryRulePopup">取消</a>
          <a class="button submit" @click="updateTempRuleSettings">確定</a>
        </div>
      </div>
    </div>
    <!-- Delete DIALOG -->
    <el-dialog :visible.sync="dialogs.delete.show">
      <div class="row justify-content-center">
        <div
          align="center"
          v-if="!dialogs.delete.cancel && !dialogs.delete.confirm"
        >
          <i
            style="font-size: 100px; color: orange"
            class="el-icon-warning-outline"
          ></i>
          <h2>請問您確定要執行此操作嗎？</h2>
          <!-- <h4>你無法復原此外送條件與運費設定！</h4> -->
          <span slot="footer" class="dialog-footer" align="center">
            <el-button type="success" @click="removeRule"
              >是的，請刪除</el-button
            >
            <el-button type="danger" @click="dialogs.delete.cancel = true"
              >不，請保留此外送條件與運費設定</el-button
            >
          </span>
        </div>
        <div align="center" v-if="dialogs.delete.cancel">
          <i
            style="font-size: 100px; color: red"
            class="el-icon-circle-close"
          ></i>
          <h2>已取消</h2>
          <h4>您的外送條件與運費設定沒有受到任何影響</h4>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogs.delete.show = false"
              >OK</el-button
            >
          </span>
        </div>

        <div align="center" v-if="dialogs.delete.confirm">
          <i
            style="font-size: 100px; color: red"
            class="el-icon-circle-check"
          ></i>
          <h2>已刪除</h2>
          <h4>
            您的外送條件與運費設定已暫被移除，回主視窗後請按"儲存設定"以儲存最終設定
          </h4>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogs.delete.show = false"
              >OK</el-button
            >
          </span>
        </div>
      </div>
    </el-dialog>
    <!-- END Delete DIALOG -->
  </div>
</template>

<script>
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import tj from "@mapbox/togeojson";
// import moment from "moment";
import Polygons from "./Polygons"; // 不可編輯，運送條件總覽
import LogisticPolygons from "./LogisticPolygons"; // 可編輯
// import { fetchShopInfoByAccountId } from "src/javascripts/gaa/fetchData";
// import { updateBusinessInfo } from "src/javascripts/gaa/updateForConsoleLog";
import { Validator } from "vee-validate";
// 使用中文
import zh_TW from "vee-validate/dist/locale/zh_TW";
// Validator.localize('zh_TW', zh_TW);
// 用中文語這包取代英文
Validator.localize("en", zh_TW);


/** custom message */
// const required = field => `請輸入${field}`;
// const required = field => `必填`;
// const messages = {
//     required
// };
// /** custom dictionary */
// const dictionary = {
//     en: {
//         messages,
//     },
// };

// Validator.localize(dictionary);

export default {
  components: {
    FontAwesomeIcon,
    Polygons,
    LogisticPolygons
  },
  props: {
    accountId: {
      type: Number,
      default: 1
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      uploadFile: null, 
      mapkml: false, 
      preview: null,
      polygonsFromFile: [],
      businessInfo: {},
      logisticDefaultSettings: {},
      isSettingUpdated: false,
      isConfigurationUpdated: false,
      showLogisticPopup: false,
      editableVendor: {},
      showDeliveryPopup: false,
      currentEditRuleIndex: null,
      editableRule: null,
      ruleForm: {},
      // ruleParams: [],
      saving: false,
      dialogs: {
        delete: {
          show: false,
          ruleIndex: null,
          cancel: false,
          confirm: false
        }
      },
      settings: [],
      newLogisticSettings: {
        isLogistic: true,
        logisticMode: 'auto', // manual or auto
        deliveryTimeEstimateBy: 'distance', // self or distance
      }, // 暫存來進行新舊版參數轉換
      configurations: {},
      logisticVendors: [
        {
          name: "lala",
          vendor: "lala",
          title: "Lalamove",
          version: 'v2',
          img: `${process.env.BASE_URL}img/Lalamove.png`,
          display: true,
          settings: {
            accessKey: {
              display: true,
              value: null
            },
            accessToken: {
              display: true,
              value: null
            },
            merchantId: {
              display: false,
              value: null
            },
            defaultVendor: {
              display: false,
              value: null
            },
            customQuotation: {
              display: false,
              value: 0
            }
          }
        },
        {
          name: "global",
          vendor: "global",
          title: "全球",
          version: 'v2',
          img: `${process.env.BASE_URL}img/GBG.png`,
          display: true,
          settings: {
            accessKey: {
              display: true,
              value: null
            },
            accessToken: {
              display: true,
              value: null
            },
            merchantId: {
              display: true,
              value: null
            },
            defaultVendor: {
              display: false,
              value: null
            },
            customQuotation: {
              display: false,
              value: 0
            }
          }
        },
        // {
        //   name: "pandago",
        //   vendor: "pandago",
        //   title: "PandaGO",
        //   version: 'v2',
        //   img: `${process.env.BASE_URL}img/PandaGo.png`,
        //   display: true,
        //   settings: {
        //     accessKey: {
        //       display: true,
        //       value: null
        //     },
        //     accessToken: {
        //       display: true,
        //       value: null
        //     },
        //     merchantId: {
        //       display: false,
        //       value: null
        //     },
        //     defaultVendor: {
        //       display: false,
        //       value: null
        //     }
        //   }
        // },
        {
          name: "git",
          vendor: "git",
          title: "GIT",
          version: 'v1',
          img: `${process.env.BASE_URL}img/GIT.png`,
          display: true,
          settings: {
            accessKey: {
              display: false,
              value: null
            },
            accessToken: {
              display: false,
              value: null
            },
            merchantId: {
              display: false,
              value: null
            },
            defaultVendor: {
              display: true,
              value: null
            },
            customQuotation: {
              display: true,
              value: 0
            }
          }
        }
      ],
      uberUUID: '',
    };
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    },
    mapPolygons: function() {
      let polygons = [];
      if (this.ruleForm && this.ruleForm.ruleParams) {
        this.ruleForm.ruleParams.forEach(rule => {
          if (rule.polygons.length) {
            polygons.push({
              name: rule.name,
              polygons: rule.polygons
            });
          }
        });
      }
      return polygons;
    },
    isLogisticDefaultChanged() {
      if (this.businessInfo && this.logisticDefaultSettings) {
        return !(
          JSON.stringify(this.businessInfo) ===
          JSON.stringify(this.logisticDefaultSettings)
        );
      }
      return false;
    },
    isEditStatusChanged () {
      console.log('changed !!');
      // 用來判斷tab是否要顯示有修改未儲存
      // 目前只判斷了自訂運送條件和預設值
      // 物流設設和預設物流業者尚未包含在內
      return (this.isLogisticDefaultChanged || this.isConfigurationUpdated)
    },
    isDeliveryRulePopupCustomSetting() {
      let result
              result = this.configurations.logisticVersion === 'v2' || this.configurations.logisticPlatform === 'selfie' ||
               (this.configurations.logisticVersion === 'v1' && this.configurations.isGitCustomQuotation === 1);
      return result
    }
  },
  watch: {
    isEditStatusChanged: function(newVal, oldVal) {
      console.log("isEditStatusChanged newVal: ", newVal);
      if (newVal) {
        let editStatusData = {
          value: this.value
        };
        this.$emit("edit-status", editStatusData);
      } else {
        let savedStatusData = {
          value: this.value
        };
        this.$emit("saved-status", savedStatusData);
      }
    }
  },
  created() {},
  mounted() {
    this.getConfiguration();
    // this.getLogisticDefault();
    this.getLogisticSettings();
  },
  methods: {
    // onEditStatusChange() {
    //   let editStatusData = {
    //       value: this.value
    //   };
    //   this.$emit('edit-status', editStatusData);
    // },
    updateSettings(key, value) {
      this.isSettingUpdated = true;
      this.configurations[key] = value;
    },
    updateLogisticVendorRelatedSetting(vendor) {
      console.log(vendor);
      if (vendor.vendor === 'git') {
        this.updateSettings('logisticVersion', 'v1');
      } else {
        this.updateSettings('logisticVersion', 'v2');
      }
      this.isSettingUpdated = true;
    },
    showLogisticVendorPopup(vendor) {
      // this.editableVendor = JSON.parse(JSON.stringify(vendor));
      this.editableVendor = vendor;
      this.showLogisticPopup = true;
    },
    closeLogisticVendorPopup() {
      // 如果有儲存資訊要更新
      this.isSettingUpdated = true;
      this.showLogisticPopup = false;
      this.editableVendor = {};
    },
    showDeliveryRulePopup(ruleIndex) {
      this.currentEditRuleIndex = ruleIndex;
      this.editableRule = JSON.parse(
        JSON.stringify(this.ruleForm.ruleParams[this.currentEditRuleIndex])
      );
      this.showDeliveryPopup = true;
    },
    closeDeliveryRulePopup() {
      this.showDeliveryPopup = false;
      // this.editableRule = null;
      this.currentEditRuleIndex = null;
    },
    readFile() {
      this.uploadFile = this.$refs.file.files[0];
      if (
        this.uploadFile.name.includes(".kml") || 
        this.uploadFile.name.includes(".kmz")
      ) {
        this.mapkml = true;
        console.log('the uploadFile ', this.uploadFile);
        this.parseKmlDocument(this.uploadFile);
        
        // this.preview = URL.createObjectURL(this.uploadFile);
      } else {
        this.mapkml = false;
      }
    },
    parseKmlDocument(file) {
      let self = this;
      let fileReader = new FileReader()
      fileReader.onload = async (event) => {
        //Do something with result object here
        // console.log(event.target.result)
        
        let kml = new DOMParser().parseFromString(event.target.result, 'application/xml');
        // 將資料上傳，經過轉換變成可以input的格式
        // console.log('the kml data ' + kml);
        
        var convertedWithStyles = tj.kml(kml, { styles: true });

        try {
          let name = convertedWithStyles.features[0].properties.name;
          let zones = [];
          for (let map of convertedWithStyles.features) { // 不同層現在也放同一層
            console.log(map);
            if (map.geometry.type !== 'Polygon') {// Points
              continue;
            } 
            
            for (let zone of map.geometry.coordinates) {

              let tmpZone = [];
              for (let c of zone) {
                tmpZone.push({
                  y: c[0],
                  x: c[1]
                })
              }
              zones.push(tmpZone);
              
            }
          }
          // let rules = [
          //   {
          //     "minDistance": 0,
          //     "maxDistance": 0,
          //     "deliveryCharge": 0,
          //     "qtyLimit": 0,
          //     "amountLimit": 599,
          //     "polygons": zones,
          //     "type": "map",
          //     "minDistanceInMeter": 0,
          //     "maxDistanceInMeter": 0,
          //     "additionalDeliveryTime": 0,
          //     "name": name
          //   }
          // ];
          this.polygonsFromFile = JSON.parse(JSON.stringify(zones));
          console.log(this.polygonsFromFile);

          return zones;
          console.log('the rules ' + JSON.stringify(rules));
        } catch (e) {

        }
       
      }
      fileReader.readAsText(file);

    },
    updateTempRuleSettings() {
      // 運送條件設定在這裡驗證
      if (
        this.editableRule.type === "map" &&
        this.editableRule.polygons.length === 0
      ) {
        this.$message({
          type: "error",
          message: "請圈選地圖範圍，或採用距離設定"
        });
      } else {
        // 如果要做輸入驗證
        this.$validator.validate().then(valid => {
          console.log("valid: ", valid);
          console.log('update rules ' );
          if (valid) {
            if (
              JSON.stringify(this.editableRule) !==
              JSON.stringify(
                this.ruleForm.ruleParams[this.currentEditRuleIndex]
              )
            ) {
              this.isConfigurationUpdated = true;
            }
            this.ruleForm.ruleParams[this.currentEditRuleIndex] = JSON.parse(
              JSON.stringify(this.editableRule)
            );
            console.log('the rule form is ' + JSON.stringify(this.ruleForm));
            this.closeDeliveryRulePopup();
          } else {
            this.$message({
              type: "error",
              message: "請確認欄位是否有正確填寫"
            });
          }
        });
        // if (JSON.stringify(this.editableRule) !== JSON.stringify(this.ruleForm.ruleParams[this.currentEditRuleIndex])) {
        //   this.isConfigurationUpdated = true;
        // }
        // this.ruleForm.ruleParams[this.currentEditRuleIndex] = JSON.parse(
        //   JSON.stringify(this.editableRule)
        // );
        // this.closeDeliveryRulePopup();
      }
    },
    addNewRule() {
      let defaultRule = {
        type: "distance",
        name: null,
        polygons: [],
        minDistance: 0,
        maxDistance: 0,
        minDistanceInMeter: 0,
        maxDistanceInMeter: 0,
        deliveryCharge: 0,
        additionalDeliveryTime: 0,
        qtyLimit: "",
        amountLimit: ""
      };
      // this.ruleParams.push(defaultRule);
      let index = this.ruleForm.ruleParams.length;
      // defaultRule.minDistance = this.ruleForm.ruleParams[index-1].maxDistance;
      // defaultRule.minDistanceInMeter = this.ruleForm.ruleParams[index-1].maxDistanceInMeter;
      // defaultRule.maxDistance = defaultRule.minDistance + 1;
      // defaultRule.maxDistanceInMeter = defaultRule.minDistanceInMeter + 1000;
      this.ruleForm.ruleParams.push(defaultRule);
      this.isConfigurationUpdated = true;
      // this.onEditStatusChange();
      this.showDeliveryRulePopup(index, "new");
    },
    showRemoveDialog(index) {
      this.dialogs.delete.show = true;
      this.dialogs.delete.ruleIndex = index;
      this.dialogs.delete.cancel = false;
      this.dialogs.delete.confirm = false;
    },
    removeRule() {
      let self = this;
      self.dialogs.delete.confirm = true;
      let ruleIndex = self.dialogs.delete.ruleIndex;
      self.ruleForm.ruleParams.splice(ruleIndex, 1);
      this.isConfigurationUpdated = true;
    },
    saveLogisticSettings() {
      let self = this;
      
      if (self.configurations.logisticVersion === "v2") {
        self.configurations.isLogistic = 1;
        self.configurations.isLala = 0;
        if (self.configurations.logisticPlatform === "selfie") {
          self.configurations.logisticMode = "selfie";
          self.settings = [];
        } else {
          // 現在v2只會有private的情況
          self.configurations.logisticWallet = 'private';
          // if (self.configurations.logisticWallet === "private") {
            if (!self.settings || !self.settings[0]) {
              // alert("自有物流需新增至少一組物流業者帳號");
              this.$message({
                type: "warning",
                message: '自有物流需新增至少一組物流業者帳號'
              });
              throw new Error("Missing required logistic settings");
            }
          // } else {
          //   self.settings = [];
          // }
          if (
            !self.configurations.logisticMode ||
            self.configurations.logisticMode === "selfie"
          ) {
            // alert("請選擇拋單模式");
            this.$message({
              type: "warning",
              message: '請選擇拋單模式'
            });
            throw new Error("missing required logistic mode");
          }
        }
      } else { // v1
        self.configurations.isLogistic = 0;
        if (self.configurations.logisticPlatform === 'platform') {
          self.configurations.isLala = 1; 
        } else {
          self.configurations.isLala = 0;
        }

        if (self.configurations.logisticDefaultVendor === 'git') {
          self.configurations.logisticDefaultVendor = 'lala'; // git在系統中沒有這個數值
        }
      }
      console.log('the logistic vendors ' + JSON.stringify(self.logisticVendors));
      if (self.logisticVendors) {
        for (let v of self.logisticVendors) {
          if (v.vendor === 'git') {
            self.configurations.gitDefaultVendor = v.settings.defaultVendor ? v.settings.defaultVendor.value : null;
            self.configurations.isGitCustomQuotation = v.settings.customQuotation ? v.settings.customQuotation.value : 0;
          } else {
            if (v.settings.accessKey.value) {
              // console.log('what is the data? ', v);
              self.settings.push({ 
                // "accountId": 97,
                // "businessId": 98,
                // "shopId": "D_4omzNAz2m",
                "vendor": v.vendor,
                "merchantId": v.settings.merchantId ? v.settings.merchantId.value : null,
                "accessKey": v.settings.accessKey ? v.settings.accessKey.value : null,
                "accessToken": v.settings.accessToken ? v.settings.accessToken.value : null
              })
              
            }
          }
          
        }
      }
      let finalSettings = [];
      if (self.settings && self.settings[0]) {
        for (let s of self.settings) {
          if (!s.vendor)
            continue;

          finalSettings.push(s);
        }
      }

      let data = {
        configurations: self.configurations,
        settings: finalSettings,
        uberUUID: self.uberUUID
        // settings: self.settings
      };

      // console.log('self settings content ' + JSON.stringify(data));
      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${this.accountId}/logistic-settings`,
          data
        )
        .then(response => {
          console.log("the data " + JSON.stringify(response.data));
          // alert("儲存設定成功");
          this.$message({
            type: "success",
            message: '儲存設定成功'
          });
          self.getLogisticSettings();
          self.isSettingUpdated = false;
          return response.data;
        })
        .catch(e => {
          // alert("儲存失敗!!");
          this.$message({
            type: "error",
            message: '儲存失敗!!'
          });
        });
    },
    getLogisticSettings() {
      let self = this;
      // 資料格式範例
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${this.accountId}/logistic-settings`
        )
        .then(response => {
          if (!response.data) return;

          // 預設值處理
          if (response.data.configurations.isLogistic) {
            response.data.configurations.logisticVersion = "v2";

          } else {
            response.data.configurations.logisticVersion = "v1";
            if (response.data.configurations.isLala) {
              response.data.configurations.logisticPlatform = 'platform';
              response.data.configurations.logisticWallet = "public";
              response.data.configurations.logisticMode = 'auto';
            } else {
              response.data.configurations.logisticPlatform = 'selfie';
              response.data.configurations.logisticMode = 'auto';
              response.data.configurations.logisticWallet = "public";
            }
          }

          if (
            !response.data.configurations.logisticMode ||
            response.data.configurations.logisticMode === "selfie"
          ) {
            response.data.configurations.logisticMode = "selfie";
            response.data.configurations.logisticPlatform = "selfie";
          // } else {
          //   console.log('no? ' +  response.data.configurations.logisticMode);
          //   response.data.configurations.logisticPlatform = "platform";
          }

          if (response.data.configurations.logisticWallet !== "private")
            response.data.configurations.logisticWallet = "public";

          if (response.data.configurations.logisticDefaultVendor !== "global")
            response.data.configurations.logisticDefaultVendor = "lala";

          // 資料處理
          if (response.data.configurations.logisticVersion == "v1") { // GIT
            response.data.configurations.logisticDefaultVendor = "git";
            
          } 
          response.data.settings = response.data.settings || [];
          
          let settingMap = {};
          for (let s of response.data.settings) {
            
            settingMap[s.vendor] = s;
          }
          
          for (let ds of this.logisticVendors) {
            if (ds.vendor === 'git') {
              ds.settings.defaultVendor.value = response.data.configurations.gitDefaultVendor;
              ds.settings.customQuotation.value = response.data.configurations.isGitCustomQuotation;
            } 
            if (settingMap[ds.vendor]) {
        
              try {
                ds.settings.accessKey.value = settingMap[ds.vendor].accessKey;
                ds.settings.accessToken.value = settingMap[ds.vendor].accessToken;
                ds.settings.merchantId.value = settingMap[ds.vendor].merchantId;                  
              } catch (e) {
                console.log('debug ', e);
              }      
            }
          }
          // console.log('conf ' + JSON.stringify(response.data.settings));


          self.logisticDefaultSettings = response.data.default || {};
          self.businessInfo = JSON.parse(JSON.stringify(self.logisticDefaultSettings));
          self.configurations = response.data.configurations || {};

          self.settings = response.data.settings || [];

          if (response.data.settings.length && response.data.settings[0].gitDefaultVendor === 'uber') 
            self.uberUUID = response.data.settings[0].gitDefaultMerchantId;
        })
        .catch(e => {
          console.log("failed " + e.stack);
        });
    },
    getConfiguration() {
      let self = this;
      // 資料格式範例
      return axios
        .get(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${this.accountId}/logistic-rules`
        )
        .then(response => {
          // convert km to m
          //console.log('-------------logistic-rules', response.data);
          let rules = response.data.map(function(rule) {
            // rule.minDistanceInMeter = rule.minDistance * 1000;
            // rule.maxDistanceInMeter = rule.maxDistance * 1000;
            if (!rule.hasOwnProperty("polygons")) {
              rule.polygons = [];
            }
            if (!rule.type) {
              rule.type = "distance";
            }

            // minDistanceInMeter/maxDistanceInMeter 若未定義
            // 則根據minDistance/maxDistance的值給預設值
            if (
              (rule.minDistanceInMeter === null ||
                rule.minDistanceInMeter === undefined) &&
              rule.minDistance >= 0
            ) {
              rule.minDistanceInMeter = rule.minDistance * 1000;
            }

            if (
              (rule.maxDistanceInMeter === null ||
                rule.maxDistanceInMeter === undefined) &&
              rule.maxDistance >= 0
            ) {
              rule.maxDistanceInMeter = rule.maxDistance * 1000;
            }
            //rule.polygons = [ [ { "x": 25.059575081675924, "y": 121.54239551744384 }, { "x": 25.058124171488362, "y": 121.5413959146764 }, { "x": 25.058551807750067, "y": 121.54478622687122 }, { "x": 25.060301213280887, "y": 121.54472185385487 }, { "x": 25.059575081675924, "y": 121.54239551744384 } ] ];
            return rule;
          });

          let confs = {
            // ruleParams: response.data
            ruleParams: rules
            // ruleParams: [
            //   {
            //     minDistance: 0,
            //     maxDistance: 2,
            //     deliveryCharge: 0,
            //     qtyLimit: 0,
            //     amountLimit: 0
            //   },
            //   {
            //     minDistance: 2,
            //     maxDistance: 10,
            //     deliveryCharge: 10,
            //     qtyLimit: 0,
            //     amountLimit: 100
            //   }
            // ]
          };
          // this.ruleParams = confs.ruleParams;
          self.ruleForm = confs;
          // console.log("what the result? " + JSON.stringify(self.ruleForm));
        });
    },
    saveConfiguration() {
      // 表單是否有效
      let self = this;
      self.saving = true;
      let rules = this.ruleForm.ruleParams.map(function(rule) {
        rule.minDistance = rule.minDistanceInMeter / 1000;
        rule.maxDistance = rule.maxDistanceInMeter / 1000;
        return rule;
      });
      //console.log('----------ruleParms:', this.ruleForm.ruleParams)
      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${this.accountId}/logistic-rules`,
          this.ruleForm.ruleParams
        )
        .then(response => {
          console.log("the data " + JSON.stringify(response.data));
          // alert("儲存設定成功");
          this.$message({
            type: "success",
            message: '自訂運送條件儲存成功'
          });
          self.saving = false;
          self.isConfigurationUpdated = false;
          self.getConfiguration();
          return response.data;
        })
        .catch(e => {
          self.saving = false;
          // alert("儲存失敗!!");
          this.$message({
            type: "error",
            message: '自訂運送條件儲存失敗'
          });
        });

      // Polygons 無法用form validation進行，所以先檢查
      // for (let rule of self.ruleForm.ruleParams) {
      //   if (rule.type == "map" && rule.polygons.length == 0) {
      //     alert("無效的表單!!請圈選地圖範圍");
      //     //break;
      //     self.saving = false;
      //     return false;
      //   }
      // }
      // console.log("is rule form valid?", this.$refs.ruleForm.validate());

      // this.$refs.ruleForm.validate(valid => {
      //   if (valid) {
      //     // convert m to km
      //     let rules = this.ruleForm.ruleParams.map(function(rule) {
      //       rule.minDistance = rule.minDistanceInMeter / 1000;
      //       rule.maxDistance = rule.maxDistanceInMeter / 1000;
      //       return rule;
      //     });
      //     //console.log('----------ruleParms:', this.ruleForm.ruleParams)
      //     return axios
      //       .put(
      //         `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${this.$route.query.shop_id}/logistic-rules`,
      //         this.ruleForm.ruleParams
      //       )
      //       .then(response => {
      //         console.log("the data " + JSON.stringify(response.data));
      //         alert("儲存設定成功");
      //         self.saving = false;
      //         self.getConfiguration();
      //         return response.data;
      //       })
      //       .catch(e => {
      //         self.saving = false;
      //         alert("儲存失敗!!");
      //       });
      //   } else {
      //     self.saving = false;
      //     alert("無效的表單!!");
      //   }
      // });
      // 會把資料格式回存
      console.log("the rulesParams ?", this.ruleForm.ruleParams);
    },
    // getLogisticDefault() {
    //   fetchShopInfoByAccountId(this.accountId)
    //     .then(fetchShopInfoRes => {
    //       // console.log("fetchShopInfoRes: ", JSON.stringify(fetchShopInfoRes));
    //       this.businessId = fetchShopInfoRes.data.businessId;
    //       this.businessInfo = fetchShopInfoRes.data;
    //       this.logisticDefaultSettings = JSON.parse(
    //         JSON.stringify(fetchShopInfoRes.data)
    //       );
    //     })
    //     .catch(fetchShopInfoErr => {
    //       this.$message({
    //         type: "error",
    //         message: `商店：${this.accountId} ，無法取得資料！`
    //       });
    //     });
    // },
    saveLogisticDefault() {
      console.log("saveLogisticDefault");
      // 儲存後更新businessInfo
      let self = this;
      this.businessInfo = JSON.parse(
        JSON.stringify(this.logisticDefaultSettings)
      );
      return axios
        .put(
          `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${this.accountId}/logistic-settings`,
          {
            configurations: {
              businessId: self.configurations.businessId
            },
            default: {
              deliveryQtyTh: self.logisticDefaultSettings.deliveryQtyTh,
              deliveryAmtTh: self.logisticDefaultSettings.deliveryAmtTh,
              deliveryDistanceTh: self.logisticDefaultSettings.deliveryDistanceTh,
              logisticDistanceType: self.logisticDefaultSettings.logisticDistanceType
            }
          }
        )
        .then(response => {
          console.log("the data " + JSON.stringify(response.data));
          // alert("儲存設定成功");
          this.$message({
            type: "success",
            message: '儲存設定成功'
          });
          self.getLogisticSettings();
          self.isSettingUpdated = false;
          return response.data;
        })
        .catch(e => {
          // alert("儲存失敗!!");
          this.$message({
            type: "error",
            message: '儲存失敗!!'
          });
        });
    }
  }
};
</script>
<style scoped src="../../../../../src/assets/css/shop-console.css"></style>
<style scoped>
.is-invalid {
  color: red;
}
.display-flex {
  display: flex !important;
}
.display-none {
  display: none !important;
}
</style>
